import { ManageMembershipRequestType } from 'shared/types/graphql';

export type RequestTypesWithoutDescriptionField = Exclude<
  ManageMembershipRequestType,
  | ManageMembershipRequestType.EditBenefit
  | ManageMembershipRequestType.Upgrade
  | ManageMembershipRequestType.Transfer
  | ManageMembershipRequestType.Note
  | ManageMembershipRequestType.ManualAdjusment
>;

export const descriptionFieldLabel: Record<RequestTypesWithoutDescriptionField, string> = {
  [ManageMembershipRequestType.OptOut]: 'Please provide feedback to help us improve Care Plans:',
  [ManageMembershipRequestType.Cancel]: 'Please describe why this membership is being cancelled:',
  [ManageMembershipRequestType.RemoveBenefit]: 'Please describe what changes are needed:',
  [ManageMembershipRequestType.Other]: 'Please describe what changes are needed:',
};

export const descriptionFieldPlaceholder: Record<RequestTypesWithoutDescriptionField, string> = {
  [ManageMembershipRequestType.OptOut]: 'Ex: Plans are too expensive, client did not see value, etc.',
  [ManageMembershipRequestType.Cancel]: 'Ex: Membership was purchased by mistake.',
  [ManageMembershipRequestType.RemoveBenefit]:
    'Ex: Need to remove a benefit consumption, change benefit usage date, etc.',
  [ManageMembershipRequestType.Other]: 'Ex: Questions about the membership, billing, etc.',
};
